import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PromiseUtilityService {
  constructor() {}

  public makePromise<T>(subscription: Observable<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      subscription.subscribe({
        next: (data: T) => {
          resolve(data);
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }
}
